import { render } from "./Points.vue?vue&type=template&id=04a9b9e1"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__